import { type UseMutationOptions, useMutation } from '@tanstack/react-query';

import { type SessionsV3SaveSessionResponse, sessionsV3SaveSession } from '@/api/generated';
import { logger } from '@/lib/logger';

type MutationParams = {
  email: string;
  dob: string;
  data: Record<string, unknown>;
};

const fetcher = async (params: MutationParams) => {
  const { data } = await sessionsV3SaveSession({
    body: {
      email: params.email,
      dob: params.dob,
      data: params.data,
    },
  });

  return data;
};

/**
 * Mutation hook for saving user session data.
 * Used for auto-save on step transitions.
 * Fails silently - does not block user flow.
 */
export function useSessionSaveMutation(
  options?: UseMutationOptions<SessionsV3SaveSessionResponse, Error, MutationParams>
) {
  return useMutation({
    mutationFn: fetcher,
    onError: (error) => {
      logger.error('Failed to save session', error);
    },
    ...options,
  });
}
